import styled, { css } from "styled-components";
import { Link } from 'react-router-dom';
import { hex2rgba } from "../../utils/styles";

export const StyledButton = styled.button`
    position: relative;
    ${({ theme }) => theme.fonts.mulishBold};
    font-size: 11px;
    line-height: 1;
    letter-spacing: -0.025em;
    text-transform: uppercase;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border-radius: 20px;
    border: 0;
    outline: none;
    cursor: pointer;
    transition: all 0.3s;
    ${({ theme, variant }) => variant === 'contained' && css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.purple};
        :hover {
            background-color: ${theme.colors.purpleHover};
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
        }
    `};
    ${({ theme, variant }) => variant === 'text' && css`
        color: ${theme.colors.purple};
        background-color: transparent;
        :hover {
            background-color: ${hex2rgba(theme.colors.purpleHover, 0.04)};
        }
    `};
    ${({ fullWidth }) => fullWidth && css`
        width: 100%;
    `};
    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
    `};
    ${({ size }) => size === 'small' && css`
        padding: 10px 12px;
    `};
    ${({ size }) => size === 'medium' && css`
        padding: 10px 24px;
    `};
    ${({ size }) => size === 'large' && css`
        padding: 10px 36px;
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;

export const StyledButtonLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    border: 0;
`;

export const StyledIcon = styled.span`
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    ${({ position }) => position === 'start' && css`
        margin-left: -6px;
        margin-right: 12px;
    `};
    ${({ position }) => position === 'end' && css`
        margin-left: 12px;
        margin-right: 6px;
    `};
`;